var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { BrandingPreviewBase } from "../../branding/branding-preview-base";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { I18N } from "aurelia-i18n";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { BrandClientService, TemplateType } from "../../../../../services/modules/brand-client.service";
import { AttachmentClientService } from "../../../../../services/modules/attachements-client.service";
import { CacheClient } from "../../../../../services/basics/client-caching.service";
import { InstantGameBrandingColors } from "./branding-steps/instant-game-branding-colors";
import { InstantGameBrandingImages } from "./branding-steps/instant-game-branding-images";
import { InstantGameBrandingText } from "./branding-steps/instant-game-branding-text";
import { InstantGameBrandingAds } from "./branding-steps/instant-game-branding-ads";
import { StepEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { JsonLockClientService } from "../../../../../services/modules/json-lock-client-service";
var InstantGameBrandingDialog = /** @class */ (function (_super) {
    __extends(InstantGameBrandingDialog, _super);
    function InstantGameBrandingDialog(element, notificationService, i18N, eventAggregator, lookupClientService, cacheClient, instantGameBrandingText, instantGameBrandingImages, instantGameBrandingColors, instantGameBrandingAds, tokenClientService, dialogClientService, brandClientService, attachmentClientService, jsonLockClientService) {
        var _this = _super.call(this, element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) || this;
        _this.instantGameBrandingText = instantGameBrandingText;
        _this.instantGameBrandingImages = instantGameBrandingImages;
        _this.instantGameBrandingColors = instantGameBrandingColors;
        _this.instantGameBrandingAds = instantGameBrandingAds;
        return _this;
    }
    InstantGameBrandingDialog.prototype.getFilesToSave = function () {
        return [TemplateType.InstantGame];
    };
    InstantGameBrandingDialog.prototype.getBrandTemplateInternalName = function () { return this.item.navigationInfo.brandTemplateInternalName; };
    InstantGameBrandingDialog.prototype.getBrandThemeInternalName = function () { return this.item.navigationInfo.brandThemeInternalName; };
    InstantGameBrandingDialog.prototype.getBrandingSteps = function () {
        return [{
                title: this.i18N.tr('instant-game'),
                step: StepEnum.InstantGameBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("instant-game-branding-text"),
                        vm: this.instantGameBrandingText,
                        show: true,
                        view: '../../app/admin/instant-game/dialogs/branding-steps/instant-game-branding-text.html'
                    },
                    {
                        title: this.i18N.tr("instant-game-branding-images"),
                        vm: this.instantGameBrandingImages,
                        show: true,
                        view: '../../app/admin/instant-game/dialogs/branding-steps/instant-game-branding-images.html'
                    },
                    {
                        title: this.i18N.tr("instant-game-branding-colors"),
                        vm: this.instantGameBrandingColors,
                        show: true,
                        view: '../../app/admin/instant-game/dialogs/branding-steps/instant-game-branding-colors.html'
                    }
                ]
            }, {
                title: this.i18N.tr('ads'),
                step: StepEnum.InstantGameAdsBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("instant-game-branding-ads"),
                        vm: this.instantGameBrandingAds,
                        show: true,
                        view: '../../app/admin/instant-game/dialogs/branding-steps/instant-game-branding-ads.html'
                    }
                ]
            }];
    };
    InstantGameBrandingDialog.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.navigationInfo.brandId,
            brandName: this.item.navigationInfo.brandName,
            brandLanguages: this.item.navigationInfo.brandLanguages
        };
    };
    InstantGameBrandingDialog.prototype.getImages = function () {
        var images = [];
        if (this.instantGameBrandingImages)
            images.push(this.instantGameBrandingImages.model);
        if (this.instantGameBrandingAds && this.instantGameBrandingAds.model)
            images.push(this.instantGameBrandingAds.model.image);
        return images;
    };
    InstantGameBrandingDialog.prototype.getRoute = function () {
        return "instant-game/".concat(this.item.instantGameId);
    };
    InstantGameBrandingDialog.prototype.includesNavigationInfo = function () {
        return true;
    };
    InstantGameBrandingDialog.prototype.getRouteAdditionalData = function () {
        return "instantGameId=".concat(this.item.instantGameId);
    };
    InstantGameBrandingDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element, NotificationClientService, I18N, EventAggregator,
            LookupClientService, CacheClient, InstantGameBrandingText, InstantGameBrandingImages,
            InstantGameBrandingColors, InstantGameBrandingAds,
            TokenClient, DialogClientService, BrandClientService, AttachmentClientService,
            JsonLockClientService])
    ], InstantGameBrandingDialog);
    return InstantGameBrandingDialog;
}(BrandingPreviewBase));
export { InstantGameBrandingDialog };
